import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { withAppContext } from "../../store/contextStore";
import Uploaded from "../../Images/uploaded.png";
import {
  Row,
  Col,
  Button,
  Card,
  Typography,
  Table,
  Modal,
  Menu,
  Input,
  Select,
  Tag,
  Spin,
  Checkbox,
  Form,
  message,
  Icon,
  Upload,
  Popconfirm,
  Dropdown,
  notification,
} from "antd";
import {
  ArrowLeftOutlined,
  StopOutlined,
  CheckOutlined,
  UserOutlined,
  CloseOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Docsample from "../../Images/pdf.jpg";
import NumberFormat from "react-number-format";
import AppConfigs from "../../Config/AppConfig";
import { getDetails, list, update } from "../../api/Apis";
import { Auth, Storage } from "aws-amplify";
import moment from "moment";
import priceFormate, {
  formatPhoneNumber,
  formatPhoneNumber1,
  ordersSort,
} from "../commonFunctions";
import Driverform from "../carrier/Driverform";
import Iconedit from "../../Images/Iconedit.png";
import LocationAutocomplete from "../../Components/Autocomplete";
import {
  getCustomerOrCarrierDetails,
  updateCustomerOrCarrierDetails,
} from "../../api/OraganizationApis";
import FormItem from "antd/lib/form/FormItem";
import RichText from "../../Components/Common/RichText";
import ErrorPage from "../ErrorPage";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";
import AppConfig from "../../Config/AppConfig";

const Search = Input.Search;
const { Text } = Typography;
const { Option } = Select;
class CarrierDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      loginModal: false,
      loadHistory: [],
      totalOrdersList: [],
      carrierInfo: {},
      loginDetails: {},
      pageLoading: false,
      dataLoading: false,
      tagLoading: false,
      selectedTags: [],
      drivers: [],
      subUsers: [],
      showErrorMsg: false,
      avtivationLoading: false,
      masterData: [],
      tagsEdit: false,
      driverVisible: false,
      visible2: false,
      carrierAuditDetails: [],
      carrierLoginDetails: {},
      latLangs: {},
      documentVisible: false,
      documentTitle: "",
      uploading: false,
      uploadName: "",
      fileList: [],
      truckVisible: false,
      truckModalTitle: "",
      edit: false,
      truckLoading: false,
      editdata: [],
      trucks: [],
      driverId: "",
      driverEdit: false,
      editDriverData: [],
      formSubmitStatus: false,
      noteVisible: false,
      title: "",
      buttonText: "",
      richtTextBiofield: "",
      loadingUpdate: false,
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      type: "",
    };
  }

  componentDidMount() {
    this.setState({
      pageLoading: true,
      dataLoading: true,
    });
    this.getAuditTrailsDetails();
    this.getDetails();
  }
  getDetails = () => {
    getDetails(
      AppConfigs["getRegisterDetails"],
      this.props.match.params.id
    ).then(async (result) => {
      if (result.success) {
        let carrierDetails = result.data;
        let carrierInfo = carrierDetails["registerDetails"];
        let masterData = carrierDetails["masterData"];
        let userRes = carrierDetails["users"];
        let loadHistory = carrierDetails["leads"];
        let carrierLoginDetails = carrierDetails["loginDetails"];
        loadHistory.map((lead) => {
          lead["callForRateText"] = lead["callForRate"]
            ? "Call for Rate"
            : lead["rateValue"];
          return lead;
        });
        // Get login user details
        // let loginUserId = carrierInfo["email"];
        // let loginDetails = carrierDetails.loginDetails;
        let drivers = userRes.filter((user) => user.userProfile === "D");
        let subUsers = userRes.filter((user) => user.userProfile === "SCA");
        if ("tags" in carrierInfo) {
          let tagNames = [];
          carrierInfo["tags"].map((tag) => {
            tagNames.push(masterData.filter((t) => t.id === tag)[0]["name"]);
            return tag;
          });
          carrierInfo["tagNames"] = tagNames;
        }
        let trucks = [];
        carrierInfo["carrierFiles"] &&
          carrierInfo["carrierFiles"]["trucks"] &&
          carrierInfo["carrierFiles"]["trucks"].map((truck, index) => {
            return trucks.push({
              key: index,
              truckNumber: truck["truckNumber"],
              typeOfTruck: truck["typeOfTruck"],
              isActive: truck["isActive"],
            });
          });
        this.setState({
          carrierInfo: carrierInfo,
          loginDetails: carrierDetails.loginDetails,
          drivers: drivers,
          subUsers: subUsers,
          loadHistory: loadHistory,
          totalOrdersList: loadHistory,
          masterData: masterData,
          dataLoading: false,
          pageLoading: false,
          carrierLoginDetails,
          trucks: trucks,
        });
      } else {
        console.log(result.errors);
      }
    });
  };

  showDocumentModal = (value) => {
    this.setState({
      documentVisible: true,
      documentTitle: value,
    });
  };

  showProfileModal = () => {
    this.setState({
      visible2: true,
      selectedCarrierAddress: this.state.carrierInfo["address"],
    });
    this.props.form.setFieldsValue({
      firstName:
        this.state.loginDetails && this.state.loginDetails["firstName"],
      lastName: this.state.loginDetails && this.state.loginDetails["lastName"],
      phone:
        this.state.carrierInfo &&
        this.state.carrierInfo["phone"] &&
        this.state.carrierInfo["phone"].length === 10
          ? formatPhoneNumber(this.state.carrierInfo["phone"])
          : formatPhoneNumber1(this.state.carrierInfo["phone"]),
      companyName: this.state.carrierInfo["companyName"],
      dot: this.state.carrierInfo["dot"],
      mc: this.state.carrierInfo["mc"],
      address: this.state.carrierInfo["address"],
    });
  };

  handleUpload = () => {
    let docKeys = this.state.carrierInfo["carrierFiles"]["documents"]
        ? this.state.carrierInfo["carrierFiles"]["documents"]
        : {},
      fileName;
    if (this.state.fileList.length === 0) {
      alert("Please upload at least one new document for update!");
      return;
    }
    this.setState({
      uploading: true,
    });
    this.state.fileList.map(async (file, index) => {
      if (file["fileBelongsTo"]) {
        fileName = this.props.match.params.id + "_" + file["name"];
        await Storage.put(fileName, file, {
          contentType: file.type,
        })
          .then((result) => {
            docKeys[file["fileBelongsTo"]] = [];
            docKeys[file["fileBelongsTo"]].push(result.key);
            if (this.state.fileList.length === index + 1) {
              let data = {
                entityData: {
                  carrierFiles: {
                    documents: docKeys,
                    trucks:
                      this.state.carrierInfo["carrierFiles"] &&
                      this.state.carrierInfo["carrierFiles"]["trucks"]
                        ? this.state.carrierInfo["carrierFiles"]["trucks"]
                        : [],
                  },
                  isDocumentUpload: true,
                },
              };
              updateCustomerOrCarrierDetails(
                this.props.match.params.id,
                data
              ).then((result) => {
                if (result.success) {
                  this.setState({
                    documentsUploaded: true,
                  });
                  getCustomerOrCarrierDetails(this.props.match.params.id).then(
                    (result) => {
                      if (result.success) {
                        this.setState({
                          documentVisible: false,
                          documentTitle: "",
                          carrierInfo: result?.data,
                        });
                      }
                    }
                  );
                } else {
                  console.log(result.errors);
                  this.setState({
                    documentVisible: false,
                    documentTitle: "",
                  });
                }
              });
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };

  getAddress = (address, latLng, fieldId) => {
    this.props.form.setFieldsValue({
      [fieldId]: address,
    });
    let latLangs = this.state.latLangs;
    this.setState({
      latLangs,
    });
  };

  profileHandleOk = (e) => {
    this.setState({
      visible2: false,
    });
  };

  profileHandleCancel = (e) => {
    this.setState({
      visible2: false,
    });
  };

  getAuditTrailsDetails = () => {
    list("auditTrail", {
      typeofPage: "carrierDetails",
      recordId: this.props.match.params.id,
    })
      .then((details) => {
        if (details.success) {
          let totalAudit = details.data.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : -1
          );
          totalAudit = details.data.filter((eachAudit) =>
            eachAudit.auditTrailDetails.filter(
              (o) => o.changedFieldName !== "recordId"
            )
          );
          this.setState({
            carrierAuditDetails: totalAudit,
          });
        }
      })
      .catch((err) => console.log(err, "errrrr"));
  };
  logoutuser = async () => {
    const AWS = require("aws-sdk");

    AWS.config.update({
      accessKeyId: "YOUR_ACCESS_KEY_ID",
      secretAccessKey: "YOUR_SECRET_ACCESS_KEY",
      region: `${AppConfig.APP_COGNITO_REGION}`, // e.g., 'us-east-1'
    });

    const cognitoIdentityServiceProvider =
      new AWS.CognitoIdentityServiceProvider();

    const userPoolId = `${AppConfig.APP_COGNITO_USER_POOL_ID}`;
    const username = this.state.carrierInfo.email;

    const params = {
      UserPoolId: userPoolId,
      Username: username,
    };

    cognitoIdentityServiceProvider.adminUserGlobalSignOut(
      params,
      (err, data) => {
        if (err) {
          console.error("Error logging out the user:", err);
        } else {
          console.log("User logged out successfully:", data);
        }
      }
    );
  };
  changeCustomerStatus = async (approvalStatus, isActive) => {
    this.setState({
      loading: true,
    });
    let data = {
      entityData: {
        approvalStatus: approvalStatus,
        isActive: isActive,
      },
    };
    if (approvalStatus === "A") {
      data["entityData"]["tags"] = this.state.selectedTags;
    }
    update(
      AppConfigs["entityNames"]["registrations"],
      this.props.match.params.id,
      data
    ).then((result) => {
      if (result.success) {
        // this.logoutuser();
        window.location.reload();
      } else {
        console.log(result.errors);
      }
    });
  };

  changeDriverStatus = async (isActive, id) => {
    this.setState({
      loading: true,
    });
    let data = {
      entityData: {
        isActive: isActive,
      },
    };
    update(AppConfigs["entityNames"]["users"], id, data).then((result) => {
      if (result.success) {
        message.success(`Driver details updated successfully.`);
        this.getDetails();
      } else {
        console.log(result.errors);
      }
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  changeTags = (list) => {
    this.setState({
      selectedTags: list,
    });
  };
  handleOk = (e) => {
    e.preventDefault();
    if (this.state.selectedTags.length === 0) {
      this.setState({
        showErrorMsg: true,
      });
      return;
    }
    this.setState({
      tagLoading: true,
    });
    this.changeCustomerStatus("A", true);
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  showLoginModal = () => {
    this.setState({
      loginModal: true,
    });
  };

  handleLoginOk = (e) => {
    this.setState({
      loginModal: false,
    });
  };

  handleLoginCancel = (e) => {
    this.setState({
      loginModal: false,
    });
  };

  fileDownload = async (fileName, downloadFileName, companyName) => {
    let savedFileName = downloadFileName + "_" + companyName.replace(/ /g, "");
    this.setState({
      dataLoadingStatus: true,
    });
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, savedFileName)
    );
  };

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    this.setState({
      pageLoading: false,
    });
    return a;
  }

  async resendConfirmationCode(username) {
    try {
      this.setState({ avtivationLoading: true });
      await Auth.resendSignUp(username);
      this.setState({ avtivationLoading: false, loginModal: false });
      message.success("code resent successfully");
    } catch (err) {
      this.setState({ avtivationLoading: false });
      message.error(err.message);
      console.log("error resending code: ", err);
    }
  }

  updateTags = async () => {
    this.setState({
      pageLoading: true,
      dataLoading: true,
    });
    let tags = this.props.form.getFieldValue("tags");
    let data = {
      entityData: {
        tags: tags,
      },
    };
    update(
      AppConfigs["entityNames"]["registrations"],
      this.props.match.params.id,
      data
    ).then((result) => {
      if (result.success) {
        window.location.reload();
      } else {
        console.log(result.errors);
      }
    });
  };

  searchData = (event, searchType) => {
    let searcingValue = searchType === "text" ? event.target.value : event;
    let totalOrdersList = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      totalOrdersList = this.state.totalOrdersList.filter(
        (load) =>
          load.customerName.toLowerCase().indexOf(searcingValue) > -1 ||
          ("deliveryTruck" in load &&
            load.deliveryTruck.toLowerCase().indexOf(searcingValue) > -1) ||
          AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][load.orderStatus]
            .toLowerCase()
            .indexOf(searcingValue) > -1 ||
          moment(load.createdAt).format("MM/DD/YYYY").indexOf(searcingValue) >
            -1 ||
          ("distanceMiles" in load &&
            load.distanceMiles &&
            load.distanceMiles.toString().indexOf(searcingValue) > -1) ||
          load.callForRateText.toString().toLowerCase().indexOf(searcingValue) >
            -1
      );
    } else {
      totalOrdersList = this.state.totalOrdersList;
      this.setState({
        defaultStatus: "",
      });
    }
    this.setState({
      loadHistory: totalOrdersList,
    });
  };

  addDriver = (id) => {
    this.setState({
      driverVisible: true,
      driverId: id,
    });
  };

  resetToPreview = () => {
    this.setState({
      driverVisible: false,
      driverId: "",
    });
  };
  handleEventRender = (event) => {
    return (
      <>
        {event.changedFieldName === "firstName" ? (
          <>
            <p style={{ color: "black", fontSize: "14px" }}>
              First Name Changed from <b>{event.oldFields}</b> to{" "}
              <b>{event.modifiedField}</b>
            </p>
          </>
        ) : event.changedFieldName === "lastName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Last Name Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "richTextEditior" ? (
          <div style={{ display: "flex" }}>
            Notes Changed from &nbsp;{" "}
            <div
              dangerouslySetInnerHTML={{
                __html: `${event.oldFields ? event.oldFields : ""}`,
              }}
            />{" "}
            &nbsp; to &nbsp;{" "}
            <div
              dangerouslySetInnerHTML={{
                __html: `${event.modifiedField ? event.modifiedField : ""}`,
              }}
            />
          </div>
        ) : event.changedFieldName === "presentCreditAmount" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Credit Limit changed from{" "}
            <b>
              {event.oldFields !== "" && (
                <>
                  <NumberFormat
                    value={parseFloat(event.oldFields).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                  {" to "}
                </>
              )}
            </b>
            <b>
              <NumberFormat
                value={parseFloat(event.modifiedField).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </b>
          </p>
        ) : event.changedFieldName === "address" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Address Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "phone" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Phone Changed from <b> {formatPhoneNumber(event.oldFields)}</b> to{" "}
            <b> {formatPhoneNumber(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "companyName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Company Name Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "wc" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Workers Compensation &nbsp;
            {"allChangedFields" in event === true
              ? event.allChangedFields.length > 0 &&
                event.allChangedFields[2] === "amount"
                ? "Amount"
                : event.allChangedFields[2] === "policyNo"
                ? "Policy Number"
                : "Expiry Date"
              : "Amount & Policy Num"}{" "}
            &nbsp; Changed from
            <b>
              &nbsp;{" "}
              {"allChangedFields" in event === true
                ? event.allChangedFields.length > 0 &&
                  event.allChangedFields[2] === "amount"
                  ? priceFormate(event.oldFields)
                  : event.oldFields
                : event.oldFields}{" "}
            </b>
            &nbsp; to&nbsp;{" "}
            <b>
              {"allChangedFields" in event === true
                ? event.allChangedFields.length > 0 &&
                  event.allChangedFields[2] === "amount"
                  ? priceFormate(event.modifiedField)
                  : event.modifiedField
                : event.modifiedField}
            </b>
          </p>
        ) : event.changedFieldName === "ac" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Auto Insurance &nbsp;
            {"allChangedFields" in event === true
              ? event.allChangedFields.length > 0 &&
                event.allChangedFields[2] === "amount"
                ? "Amount"
                : event.allChangedFields[2] === "policyNo"
                ? "Policy Number"
                : "Expiry Date"
              : "Amount & Policy Num"}{" "}
            &nbsp; Changed from
            <b>&nbsp; {event.oldFields}</b> &nbsp;to&nbsp;{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "gli" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            General Liability Insurance &nbsp;
            {"allChangedFields" in event === true
              ? event.allChangedFields.length > 0 &&
                event.allChangedFields[2] === "amount"
                ? "Amount"
                : event.allChangedFields[2] === "policyNo"
                ? "Policy Number"
                : "Expiry Date"
              : "Amount & Policy Num"}{" "}
            &nbsp; Changed from&nbsp;
            <b>{event.oldFields}</b> &nbsp;to&nbsp; <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "iD" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Insurance Documents changed from
            <b> &nbsp;{event.oldFields}</b>&nbsp; to &nbsp;
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "nda" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            NDA Documents changed from
            <b> &nbsp;{event.oldFields}</b>&nbsp; to &nbsp;
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "w9" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            W-9 Documents changed from
            <b> &nbsp;{event.oldFields}</b>&nbsp; to &nbsp;
            <b>{event.modifiedField}</b>
          </p>
        ) : (
          ""
        )}
      </>
    );
  };
  updateUserDetails = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["firstName", "lastName", "phone", "companyName", "dot", "mc", "address"],
      (err, values) => {
        if (!err) {
          this.setState({
            loadingUpdate: true,
          });
          let data = {};
          data["entityData"] = {};
          data["entityData"]["firstName"] = values["firstName"];
          data["entityData"]["lastName"] = values["lastName"];
          console.log(data);
          // let userDetails = JSON.parse(localStorage.getItem("userDetails"));
          update(
            AppConfigs["entityNames"]["users"],
            this.state.carrierLoginDetails.id,
            data
          ).then(async (result) => {
            if (result.success) {
              // userDetails["firstName"] = data["entityData"]["firstName"];
              // userDetails["lastName"] = data["entityData"]["lastName"];
              // localStorage.setItem("userDetails", JSON.stringify(userDetails));
              data = {};
              data["entityData"] = {};
              data["entityData"]["phone"] = values["phone"];
              data["entityData"]["companyName"] = values["companyName"];
              data["entityData"]["dot"] = values["dot"];
              data["entityData"]["mc"] = values["mc"];
              data["entityData"]["address"] = values["address"];
              data["entityData"]["latLangs"] = this.state.latLangs;
              data["entityData"]["city"] = null;
              data["entityData"]["stateText"] = null;
              data["entityData"]["zip"] = null;
              update(
                AppConfigs["entityNames"]["registrations"],
                this.props.match.params.id,
                data
              ).then(async (result) => {
                if (result.success) {
                  this.getDetails();
                  this.getAuditTrailsDetails();
                  this.setState({
                    loadingUpdate: false,
                    visible2: false,
                  });
                } else {
                  this.setState({
                    loading: false,
                  });
                  console.log(result.errors);
                }
              });
            } else {
              this.setState({
                loading: false,
              });
              console.log(result.errors);
            }
          });
        }
      }
    );
  };

  deleteDocument = async (item) => {
    this.setState({
      loading: true,
    });
    let updatedDocuments = {
      ...this.state.carrierInfo["carrierFiles"]["documents"],
    };
    updatedDocuments[item] = [];
    let data = {
      entityData: {
        carrierFiles: {
          documents: updatedDocuments,
          trucks:
            this.state.carrierInfo["carrierFiles"] &&
            this.state.carrierInfo["carrierFiles"]["trucks"]
              ? this.state.carrierInfo["carrierFiles"]["trucks"]
              : [],
        },
        isDocumentUpload: true,
      },
    };
    updateCustomerOrCarrierDetails(this.props.match.params.id, data).then(
      (result) => {
        if (result.success) {
          message.success("Document deleted successfully");
          getCustomerOrCarrierDetails(this.props.match.params.id).then(
            (result) => {
              if (result.success) {
                this.setState({
                  loading: false,
                  carrierInfo: result.data,
                });
              }
            }
          );
        } else {
          console.log(result.errors);
        }
      }
    );
    this.setState({
      loading: false,
    });
  };

  addTruck = () => {
    this.setState({
      truckVisible: true,
      truckModalTitle: "Add New Truck",
    });
    this.props.form.setFieldsValue({
      typeOfTruck1: "",
      truckNumber1: "",
    });
  };

  handleAddTruckCancel = () => {
    this.setState({
      truckVisible: false,
      edit: false,
      editdata: [],
    });
  };

  handleAddTruckOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["typeOfTruck1", "truckNumber1"],
      (err, values) => {
        if (!err) {
          this.setState({
            truckLoading: true,
          });
          let trucks = [];
          if (this.state.edit) {
            this.state.trucks.map((truck) => {
              if (truck["key"] === this.state.editdata[0]["key"]) {
                trucks.push({
                  truckNumber: values["truckNumber1"],
                  typeOfTruck: values["typeOfTruck1"],
                  isActive: truck["isActive"],
                });
              } else {
                trucks.push({
                  truckNumber: truck["truckNumber"],
                  typeOfTruck: truck["typeOfTruck"],
                  isActive: truck["isActive"],
                });
              }
              return true;
            });
            this.setState({
              editdata: [],
              edit: false,
            });
          } else {
            console.log("++", this.state.carrierInfo["carrierFiles"]);
            if ("trucks" in this.state.carrierInfo["carrierFiles"]) {
              trucks = this.state.carrierInfo["carrierFiles"]["trucks"];
            }
            trucks.push({
              truckNumber: values["truckNumber1"],
              typeOfTruck: values["typeOfTruck1"],
              isActive: true,
            });
          }
          let carrierFiles = {
            documents: this.state.carrierInfo["carrierFiles"]["documents"],
            trucks: trucks,
          };
          let data = {
            entityData: {
              carrierFiles: carrierFiles,
            },
          };
          update(
            AppConfigs["entityNames"]["registrations"],
            this.props.match.params.id,
            data
          ).then((result) => {
            if (result.success) {
              let trucks = [];
              result.data.data.carrierFiles.trucks.map((truck, index) => {
                return trucks.push({
                  key: index,
                  truckNumber: truck["truckNumber"],
                  typeOfTruck: truck["typeOfTruck"],
                });
              });
              this.setState({
                trucks: trucks,
                edit: false,
                truckVisible: false,
                truckLoading: false,
              });
            } else {
              console.log(result.errors);
            }
          });
        }
      }
    );
  };

  showEditModal = (key) => {
    const dataSource = this.state.trucks;
    const edit = dataSource.filter((item) => item.key === key);
    this.props.form.setFieldsValue({
      typeOfTruck1: edit[0]["typeOfTruck"],
      truckNumber1: edit[0]["truckNumber"],
    });
    this.setState({
      truckModalTitle: "Edit Truck",
      edit: true,
      truckVisible: true,
      editdata: edit,
    });
  };

  handleEditDriverCancel = () => {
    this.setState({
      driverEdit: false,
      editDriverData: [],
    });
  };

  showDriverEditModal = (type, id) => {
    let dataSource, userData;
    if (type === "Driver") {
      dataSource = this.state.drivers;
      userData = dataSource.filter((item) => item.id === id);
    }
    if (type === "SubUser") {
      dataSource = this.state.subUsers;
      userData = dataSource.filter((item) => item.id === id);
    }
    this.props.form.setFieldsValue({
      firstName: userData[0]["firstName"],
      lastName: userData[0]["lastName"],
      phone: userData[0]["phone"],
      email: userData[0]["email"],
    });
    this.setState({
      driverEdit: true,
      editDriverData: userData,
      driverId: id,
      type: type,
    });
  };

  handleEditDriver = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["firstName", "lastName", "phone", "email"],
      async (err, values) => {
        if (!err) {
          this.setState({
            formSubmitStatus: true,
          });
          let data = {};
          data["entityData"] = values;
          update(
            AppConfigs["entityNames"]["users"],
            this.state.driverId,
            data
          ).then((result) => {
            if (result.success) {
              message.success(
                `${this.state.type} details updated successfully.`
              );
              this.getDetails();
            } else {
              console.log(result.errors);
            }
            this.setState({
              formSubmitStatus: false,
              driverId: "",
              driverEdit: false,
              pageLoading: true,
            });
          });
        }
      }
    );
  };

  changeTruckStatus = (isActive, key) => {
    this.setState({
      pageLoading: true,
    });
    let trucks = [];
    const edit = this.state.trucks.filter((item) => item.key === key);
    this.state.trucks.map((truck) => {
      if (truck["key"] === edit[0]["key"]) {
        trucks.push({
          truckNumber: truck["truckNumber"],
          typeOfTruck: truck["typeOfTruck"],
          isActive: isActive,
        });
      } else {
        trucks.push({
          truckNumber: truck["truckNumber"],
          typeOfTruck: truck["typeOfTruck"],
          isActive: truck["isActive"],
        });
      }
      return true;
    });
    let carrierFiles = {
      documents: this.state.carrierInfo["carrierFiles"]["documents"],
      trucks: trucks,
    };
    let data = {
      entityData: {
        carrierFiles: carrierFiles,
      },
    };
    update(
      AppConfigs["entityNames"]["registrations"],
      this.props.match.params.id,
      data
    ).then((result) => {
      if (result.success) {
        let trucks = [];
        result.data.data.carrierFiles.trucks.map((truck, index) => {
          return trucks.push({
            key: index,
            truckNumber: truck["truckNumber"],
            typeOfTruck: truck["typeOfTruck"],
            isActive: truck["isActive"],
          });
        });
        message.success("Successfully Truck Updated");
        this.setState({
          pageLoading: false,
          trucks: trucks,
        });
      } else {
        console.log(result.errors);
      }
    });
  };
  showTextModal = (value) => {
    const buttonTitle = value?.split(" ")[0] === "Edit" ? "Update" : "Add";
    this.setState({
      noteVisible: true,
      title: value,
      buttonText: buttonTitle,
    });
  };

  updateNoteDetails = (e) => {
    e.preventDefault();
    let data = {
      entityData: {
        richTextEditior: this.state.richtTextBiofield,
      },
    };
    data["entityData"]["typeofPage"] = "carrierrDetails";
    data["entityData"]["recordId"] = this.props.match.params.id;

    update(
      AppConfigs["entityNames"]["users"],
      this.state.loginDetails["id"],
      data
    )
      .then(async (result) => {
        if (result.success) {
          this.getDetails();
          this.setState({
            noteVisible: false,
          });
          this.getAuditTrailsDetails();
        }
      })
      .catch((error) => {
        this.setState({
          noteVisible: false,
        });
        console.log(error);
        notification["error"](console.log(error));
      });
  };

  handleRichtextBio = (bio) => {
    this.setState({
      richtTextBiofield: bio,
    });
  };

  render() {
    const firstupload = {
      onChange({ file, fileList }) {
        if (file.status !== "uploading") {
        }
      },
      beforeUpload: (file) => {
        file["fileBelongsTo"] = "coi";
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
    };
    const secondupload = {
      onChange({ file, fileList }) {
        if (file.status !== "uploading") {
        }
      },
      beforeUpload: (file) => {
        file["fileBelongsTo"] = "w9";
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
    };
    const fourthupload = {
      onChange({ file, fileList }) {
        if (file.status !== "uploading") {
        }
      },
      beforeUpload: (file) => {
        file["fileBelongsTo"] = "nda";
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
    };
    const rolePermisions = this.props?.context?.state?.permissions;
    const { getFieldDecorator } = this.props.form;
    const { carrierAuditDetails, visible2 } = this.state;
    const driverColumns = [
      {
        title: <div style={{ color: "gray" }}>Full Name</div>,
        dataIndex: "firstName",
        key: "firstName",
        render: (firstName, record) => (
          <span style={{ color: "black" }}>
            {firstName + " " + record.lastName}
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Phone</div>,
        dataIndex: "phone",
        key: "phone",
        render: (phone) => (
          <div style={{ color: "black" }}>
            <span>{formatPhoneNumber(phone.slice(2))}</span>
          </div>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Email</div>,
        dataIndex: "email",
        key: "email",
        render: (email) => (
          <span>
            <div style={{ color: "black" }}>{email}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Status</div>,
        dataIndex: "isActive",
        key: "isActive",
        render: (isActive) => (
          <span>
            <div style={{ color: "black" }}>
              {isActive === true ? "Active" : "Inactive"}
            </div>
          </span>
        ),
      },
      {
        title: "",
        key: "id",
        dataIndex: "id",
        render: (id, record) => (
          <Dropdown.Button
            overlay={
              <Menu>
                <Menu.Item className="blue">
                  <Button
                    className="modalButton"
                    onClick={() => this.showDriverEditModal("Driver", id)}
                  >
                    Edit
                  </Button>
                </Menu.Item>
                <Menu.Item className="blue">
                  {record?.isActive ? (
                    <Button
                      className="modalButton"
                      onClick={() => this.changeDriverStatus(false, id)}
                    >
                      Inactive
                    </Button>
                  ) : (
                    <Button
                      className="modalButton"
                      onClick={() => this.changeDriverStatus(true, id)}
                    >
                      Active
                    </Button>
                  )}
                </Menu.Item>
              </Menu>
            }
          ></Dropdown.Button>
        ),
      },
    ];
    const subUserColumns = [
      {
        title: <div style={{ color: "gray" }}>Full Name</div>,
        dataIndex: "firstName",
        key: "firstName",
        render: (firstName, record) => (
          <span style={{ color: "black" }}>
            {firstName + " " + record.lastName}
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Email</div>,
        dataIndex: "email",
        key: "email",
        render: (email) => (
          <span>
            <div style={{ color: "black" }}>{email}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>UserProfile</div>,
        dataIndex: "userProfile",
        key: "userProfile",
        render: (userProfile) => (
          <span>
            <div style={{ color: "black" }}>
              {userProfile === "SCA" ? "Sub User" : "Carrieradmin"}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Status</div>,
        dataIndex: "isActive",
        key: "isActive",
        render: (isActive) => (
          <span>
            <div style={{ color: "black" }}>
              {isActive === true ? "Active" : "Inactive"}
            </div>
          </span>
        ),
      },
      {
        title: "",
        key: "id",
        dataIndex: "id",
        render: (id, record) => (
          <Dropdown.Button
            overlay={
              <Menu>
                <Menu.Item className="blue">
                  <Button
                    className="modalButton"
                    onClick={() => this.showDriverEditModal("SubUser", id)}
                  >
                    Edit
                  </Button>
                </Menu.Item>
                <Menu.Item className="blue">
                  {record?.isActive ? (
                    <Button
                      className="modalButton"
                      onClick={() => this.changeDriverStatus(false, id)}
                    >
                      Inactive
                    </Button>
                  ) : (
                    <Button
                      className="modalButton"
                      onClick={() => this.changeDriverStatus(true, id)}
                    >
                      Active
                    </Button>
                  )}
                </Menu.Item>
              </Menu>
            }
          ></Dropdown.Button>
        ),
      },
    ];

    const truckColumns = [
      {
        title: <div style={{ color: "gray" }}>Truck Type</div>,
        dataIndex: "typeOfTruck",
        key: "typeOfTruck",
        render: (typeOfTruck) => (
          <span>
            <div style={{ color: "black" }}>{typeOfTruck}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Truck Number</div>,
        dataIndex: "truckNumber",
        key: "truckNumber",
        render: (truckNumber) => (
          <span>
            <div style={{ color: "black" }}>{truckNumber}</div>
          </span>
        ),
      },
      {
        title: "",
        key: "id",
        render: (text, record) => (
          <Dropdown.Button
            overlay={
              <Menu>
                <Menu.Item className="blue">
                  <Button
                    className="modalButton"
                    onClick={() => this.showEditModal(record.key)}
                  >
                    Edit
                  </Button>
                </Menu.Item>
                {record.isActive === false ? (
                  <Menu.Item className="blue">
                    <Button
                      className="modalButton"
                      onClick={() => this.changeTruckStatus(true, record.key)}
                    >
                      Active
                    </Button>
                  </Menu.Item>
                ) : (
                  <Menu.Item className="blue">
                    <Button
                      className="modalButton"
                      onClick={() => this.changeTruckStatus(false, record.key)}
                    >
                      Inactive
                    </Button>
                  </Menu.Item>
                )}
              </Menu>
            }
          ></Dropdown.Button>
        ),
      },
    ];

    const columns = [
      {
        title: <div style={{ color: "gray" }}>Order #</div>,
        dataIndex: "orderId",
        key: "orderId",
        sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (orderId) => (
          <span>
            <div style={{ color: "black" }}>{orderId}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Status</div>,
        key: "orderStatus",
        dataIndex: "orderStatus",
        sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (tag) => (
          <span className="status_tag">
            <Tag
              color={AppConfigs["STATUS_COLORS"][tag]}
              style={{
                color: "black",
                height: "27px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][tag]}
            </Tag>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Contact Name</div>,
        dataIndex: "customerName",
        key: "customerName",
        sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (customerName, record) => (
          <span>
            <div style={{ color: "black" }}>{customerName}</div>
            <div className="subtext">{record["companyName"]}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Date & Time Ordered</div>,
        dataIndex: "createdAt",
        key: "createdAt",
        sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (createdAt) => (
          <span>
            <div style={{ color: "black" }}>
              {moment(createdAt).format("MM/DD/YYYY")}
            </div>
            <div className="subtext">{moment(createdAt).format("HH:mm")}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Type of truck</div>,
        dataIndex: "deliveryTruck",
        key: "deliveryTruck",
        sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (deliveryTruck, record) => (
          <span>
            <div style={{ color: "black" }}>
              {record["cartItems"][0]["deliveryTruck"]}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Date & Time Delivered</div>,
        dataIndex: "deliveryDateAndTime",
        key: "deliveryDateAndTime",
        sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (deliveryDateAndTime) => (
          <span>
            <div style={{ color: "black" }}>
              {deliveryDateAndTime &&
                moment(deliveryDateAndTime).format("MM/DD/YYYY")}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {deliveryDateAndTime &&
                moment(deliveryDateAndTime).format("hh:mm A")}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Rate paid</div>,
        dataIndex: "callForRateText",
        key: "callForRateText",
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (callForRateText, record) => (
          <span>
            <div style={{ color: "black" }}>{callForRateText}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Distance</div>,
        dataIndex: "distanceMiles",
        key: "distanceMiles",
        sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (distanceMiles, record) => (
          <span>
            <div style={{ color: "black" }}>{distanceMiles}</div>
            {/* <div className='subtext' >miles</div> */}
          </span>
        ),
      },
    ];

    const auditColumns = [
      {
        title: "DATE AND TIME",
        dataIndex: "createdAt",
        key: "createdAt",
        align: "center",
        width: "33%",
        render: (createdAt) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {moment(createdAt).format("MM/DD/YYYY hh:mm a")}
          </p>
        ),
      },
      {
        title: "ACTION DONE BY",
        dataIndex: "firstName",
        key: "createdAt",
        align: "center",
        width: "33%",
        render: (firstName, record) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {record.firstName + " " + record.lastName}
          </p>
        ),
      },
      {
        title: "EVENT",
        dataIndex: "auditTrailDetails",
        key: "auditTrailDetails",
        align: "center",
        render: (auditTrailDetails, record) => (
          <>
            {record.auditTrailDetails.map((change) =>
              this.handleEventRender(change)
            )}
          </>
        ),
      },
    ];

    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }

    return (
      <div style={{ top: "135px" }}>
        <Spin spinning={this.state.pageLoading}>
          <Row>
            <Menu
              mode={window.innerWidth < 768 ? "vertical" : "horizontal"}
              style={{ backgroundColor: "rgb(14, 77, 144)" }}
            >
              <Menu.Item key="1">
                <Link to="/app/carriers">
                  <h3 style={{ color: "#fff" }}>
                    <ArrowLeftOutlined style={{ fontSize: "1em" }} />
                    Back to list
                  </h3>
                </Link>
              </Menu.Item>
              <Menu.Item key="2" style={{ cursor: "default" }}>
                <h2 style={{ color: "#fff" }}>Carrier Details</h2>
              </Menu.Item>
              <Menu.Item key="3" style={{ cursor: "default" }}>
                <h3 style={{ color: "#fff" }}>
                  STATUS :{" "}
                  <span className="status_tag">
                    &nbsp;
                    <Tag
                      color={
                        this.state.carrierInfo["approvalStatus"] &&
                        this.state.carrierInfo["approvalStatus"] === "A"
                          ? "green"
                          : this.state.carrierInfo["approvalStatus"] === "P"
                          ? "yellow"
                          : this.state.carrierInfo["approvalStatus"] === "F"
                          ? "blue"
                          : "red"
                      }
                      key={this.state.carrierInfo["approvalStatus"]}
                      style={{
                        color: "black",
                        height: "27px",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {
                        AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][
                          this.state.carrierInfo["approvalStatus"]
                        ]
                      }
                    </Tag>
                    {/* <Button style={{ color: this.state.carrierInfo["approvalStatus"] === "A"?"green":this.state.carrierInfo["approvalStatus"] === "P"? "red":"black", height: '25px', cursor: 'default' }}>{this.state.carrierInfo["approvalStatus"] === "A" ? "Active" : this.state.carrierInfo["approvalStatus"] === "P" ? "Pending" : "Decline"}</Button></span></h3> */}
                  </span>
                </h3>
              </Menu.Item>
              <Menu.Item
                key="4"
                style={{ float: "right" }}
                onClick={this.showLoginModal}
              >
                <h3 style={{ color: "#fff", float: "right" }}>
                  <UserOutlined style={{ fontSize: "1.2em" }} />
                  LOGIN DETAILS
                </h3>
              </Menu.Item>
              {/* <Menu.Item key="6" style={{ float: 'right', borderRight: '1px solid #A2AABD' }}><h3 style={{ color: '#fff' }}>
                                {
                                    this.state.carrierInfo["approvalStatus"] === "P"?
                                        <Button style={{ background: 'red', borderColor: 'red', color: '#FFF' }} >
                                            Pending
                                        </Button>
                                    : this.state.carrierInfo["approvalStatus"] === "A"?
                                        <Button style={{ background: 'green', borderColor: 'green', color: '#FFF' }} >
                                            <CheckOutlined />Approve
                                        </Button>
                                    :
                                        <Button style={{ color: 'black' }}>
                                        <   StopOutlined />Decline
                                        </Button>
                                }
                                </h3>
                            </Menu.Item> */}
              {(this.state.carrierInfo["approvalStatus"] === "P" ||
                this.state.carrierInfo["approvalStatus"] === "D") && (
                <Menu.Item
                  key="5"
                  style={{ float: "right", borderRight: "1px solid #A2AABD" }}
                >
                  <h3 style={{ color: "#fff" }}>
                    <Button
                      style={{
                        background: "green",
                        borderColor: "green",
                        color: "#FFF",
                        fontWeight: "bold",
                      }}
                      // onClick={()=>{this.changeCustomerStatus('A',true)}}
                      onClick={this.showModal}
                      loading={this.state.loading}
                    >
                      <CheckOutlined />
                      Approve
                    </Button>
                  </h3>
                </Menu.Item>
              )}
              {this.state.carrierInfo["approvalStatus"] === "A" && (
                <Menu.Item key="6" style={{ float: "right" }}>
                  <h3 style={{ color: "#fff" }}>
                    <Button
                      style={{ color: "black", fontWeight: "bold" }}
                      onClick={() => {
                        this.changeCustomerStatus("F", false);
                      }}
                      loading={this.state.loading}
                    >
                      <StopOutlined />
                      Freeze Account
                    </Button>
                  </h3>
                </Menu.Item>
              )}
              {this.state.carrierInfo["approvalStatus"] === "F" && (
                <Menu.Item key="6" style={{ float: "right" }}>
                  <h3 style={{ color: "#fff" }}>
                    <Button
                      style={{
                        background: "green",
                        borderColor: "green",
                        color: "#FFF",
                        fontWeight: "bold",
                      }}
                      onClick={() => {
                        this.changeCustomerStatus("A", true);
                      }}
                      loading={this.state.loading}
                    >
                      <CheckOutlined />
                      Activate
                    </Button>
                  </h3>
                </Menu.Item>
              )}
              {this.state.carrierInfo["approvalStatus"] === "P" && (
                <Menu.Item key="6" style={{ float: "right" }}>
                  <h3 style={{ color: "#fff" }}>
                    <Button
                      style={{ color: "black", fontWeight: "bold" }}
                      onClick={() => {
                        this.changeCustomerStatus("D", false);
                      }}
                      loading={this.state.loading}
                    >
                      <StopOutlined />
                      Decline
                    </Button>
                  </h3>
                </Menu.Item>
              )}
              {/* <Menu.Item key="5" style={{ float: 'right' }}><h3 style={{ color: '#fff' }}>
                                <Button style={{ color: 'black' }}>
                                    <StopOutlined />Decline
                                    </Button></h3>
                            </Menu.Item> */}
            </Menu>
          </Row>

          <Row gutter={16} style={{ margin: "40px 20px" }}>
            <Col lg={6} md={6} sm={12} xs={24}>
              <Col lg={24} md={24} sm={24} xs={24}>
                <div className="site-card-border-less-wrapper">
                  <Card
                    title="Carrier Details"
                    style={{ borderRadius: "10px" }}
                    extra={
                      rolePermisions &&
                      rolePermisions[0]?.permissions?.includes(
                        "editCarrier"
                      ) && (
                        <span
                          onClick={this.showProfileModal}
                          style={{
                            color: "red",
                            cursor: "pointer",
                            textDecoration: "underline",
                            textAlign: "right",
                          }}
                        >
                          <img src={Iconedit} alt={"Edit"} />
                        </span>
                      )
                    }
                  >
                    <Row>
                      <Col lg={8} md={24} sm={24} xs={24}>
                        <Text disabled>Company</Text>
                      </Col>
                      <Col lg={16} md={24} sm={24} xs={24}>
                        <Text>{this.state.carrierInfo["companyName"]}</Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={8}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text disabled>Contact Name</Text>
                      </Col>
                      <Col
                        lg={16}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text>
                          {this.state.loginDetails &&
                            this.state.loginDetails["firstName"] +
                              " " +
                              this.state.loginDetails["lastName"]}
                        </Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={8}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text disabled>MC#</Text>
                      </Col>
                      <Col
                        lg={16}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text>{this.state.carrierInfo["mc"]}</Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={8}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text disabled>DOT#</Text>
                      </Col>
                      <Col
                        lg={16}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text>{this.state.carrierInfo["dot"]}</Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={8}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text disabled>Phone</Text>
                      </Col>
                      <Col
                        lg={16}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text>
                          {this.state.carrierInfo &&
                          this.state.carrierInfo["phone"] &&
                          this.state.carrierInfo["phone"].length === 10
                            ? formatPhoneNumber(this.state.carrierInfo["phone"])
                            : formatPhoneNumber1(
                                this.state.carrierInfo["phone"]
                              )}
                        </Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xxl={8}
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text disabled>Email</Text>
                      </Col>
                      <Col
                        xxl={16}
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <a
                          type="link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={"mailto:" + this.state.carrierInfo["email"]}
                          style={{
                            color: "#000000a6",
                          }}
                        >
                          {this.state.carrierInfo["email"]}
                        </a>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={8}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text disabled>Address</Text>
                      </Col>
                      <Col
                        lg={16}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text>{this.state.carrierInfo["address"]}</Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={8}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "3%" }}
                      >
                        <Text disabled>Tags</Text>
                      </Col>
                      {!this.state.tagsEdit ? (
                        <>
                          <Col
                            lg={10}
                            md={10}
                            sm={24}
                            xs={24}
                            style={{ marginTop: "3%" }}
                          >
                            <Text>
                              {this.state.carrierInfo["tagNames"] &&
                                this.state.carrierInfo["tagNames"].join(", ")}
                            </Text>
                          </Col>
                          <Col
                            lg={1}
                            md={1}
                            sm={2}
                            xs={2}
                            offset={1}
                            style={{ marginTop: "3%" }}
                          >
                            <h3>
                              {rolePermisions &&
                                rolePermisions[0]?.permissions?.includes(
                                  "editCarrier"
                                ) && (
                                  <EditOutlined
                                    onClick={() => {
                                      this.setState({ tagsEdit: true });
                                    }}
                                    title="edit"
                                    style={{
                                      fontSize: "1.4em",
                                      float: "right",
                                    }}
                                  />
                                )}
                            </h3>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col
                            lg={11}
                            md={11}
                            sm={24}
                            xs={24}
                            style={{ marginTop: "3%" }}
                          >
                            <Form.Item className="Formitem">
                              {getFieldDecorator("tags", {
                                rules: [{ type: "array" }],
                                initialValue: this.state.carrierInfo["tags"],
                              })(
                                <Select
                                  mode="multiple"
                                  allowClear
                                  style={{ width: "100%" }}
                                  placeholder="Please Select"
                                  showArrow
                                >
                                  {this.state.masterData
                                    .sort((a, b) =>
                                      a["name"] > b["name"] ? 1 : -1
                                    )
                                    .map((tag) => (
                                      <Option value={tag.id} key={tag.id}>
                                        {tag.name}
                                      </Option>
                                    ))}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          <Col
                            lg={1}
                            md={1}
                            sm={24}
                            xs={24}
                            style={{ marginTop: "5%" }}
                          >
                            <CheckOutlined
                              title="update"
                              onClick={this.updateTags}
                              style={{
                                fontSize: "1.2em",
                                float: "right",
                                marginTop: "5px",
                                marginRight: "-10px",
                                color: "#006400",
                              }}
                            />
                          </Col>
                          <Col
                            lg={1}
                            md={1}
                            sm={24}
                            xs={24}
                            style={{ marginTop: "5%" }}
                          >
                            <CloseOutlined
                              title="Cancel"
                              onClick={() => {
                                this.setState({ tagsEdit: false });
                              }}
                              style={{
                                fontSize: "1.2em",
                                float: "right",
                                marginTop: "5px",
                                marginRight: "-25px",
                                color: "red",
                              }}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  </Card>
                </div>
              </Col>
              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                style={{ marginTop: "2%", paddingLeft: "0px" }}
              >
                <div className="site-card-border-less-wrapper">
                  <Card
                    title="Documents"
                    style={{ borderRadius: "10px" }}
                    extra={
                      rolePermisions &&
                      rolePermisions[0]?.permissions?.includes(
                        "editCarrier"
                      ) && (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => this.showDocumentModal("Add Document")}
                        >
                          <Button
                            type="dashed"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#0E4D90",
                              width: "20px",
                              borderRadius: "50%",
                              borderColor: "#0E4D90",
                              padding: "0px",
                              height: "20px",
                            }}
                          >
                            <Icon
                              type="plus"
                              style={{
                                verticalAlign: "0px",
                                fontSize: "12px",
                                color: "white",
                              }}
                            />
                          </Button>
                          &nbsp;<span>Add Documents</span>
                        </span>
                        // </Link>
                      )
                    }
                  >
                    <Row gutter={16}>
                      {this.state.carrierInfo &&
                        this.state.carrierInfo["carrierFiles"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"][
                          "w9"
                        ].length > 0 && (
                          <Col
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                            style={{ textAlign: "center" }}
                          >
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.fileDownload(
                                  this.state.carrierInfo["carrierFiles"][
                                    "documents"
                                  ]["w9"][0],
                                  "W9",
                                  this.state.carrierInfo["companyName"]
                                );
                              }}
                            >
                              <img src={Docsample} alt="Doc" title="Download" />
                              <h4
                                style={{ color: "#7B8190", fontSize: "13px" }}
                              >
                                W-9
                              </h4>
                            </span>
                            <span>
                              {" "}
                              <Popconfirm
                                title="Are you sure you want to delete this document?"
                                onConfirm={() => this.deleteDocument("w9")}
                                style={{ width: "100px" }}
                              >
                                <DeleteOutlined
                                  style={{
                                    color: "#7b8090",
                                    fontSize: "1.3em",
                                  }}
                                  title="Delete"
                                />
                              </Popconfirm>
                            </span>
                          </Col>
                        )}
                      {this.state.carrierInfo &&
                        this.state.carrierInfo["carrierFiles"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"][
                          "nda"
                        ] &&
                        this.state.carrierInfo["carrierFiles"]["documents"][
                          "nda"
                        ].length > 0 && (
                          <Col
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                            style={{ textAlign: "center" }}
                          >
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.fileDownload(
                                  this.state.carrierInfo["carrierFiles"][
                                    "documents"
                                  ]["nda"][0],
                                  "NDA",
                                  this.state.carrierInfo["companyName"]
                                );
                              }}
                            >
                              <img src={Docsample} alt="Doc" title="Download" />
                              <h4
                                style={{ color: "#7B8190", fontSize: "13px" }}
                              >
                                NDA
                              </h4>
                            </span>
                            <span>
                              {" "}
                              <Popconfirm
                                title="Are you sure you want to delete this document?"
                                onConfirm={() => this.deleteDocument("nda")}
                                style={{ width: "100px" }}
                              >
                                <DeleteOutlined
                                  style={{
                                    color: "#7b8090",
                                    fontSize: "1.3em",
                                  }}
                                  title="Delete"
                                />
                              </Popconfirm>
                            </span>
                          </Col>
                        )}

                      {this.state.carrierInfo &&
                        this.state.carrierInfo["carrierFiles"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"][
                          "coi"
                        ] &&
                        this.state.carrierInfo["carrierFiles"]["documents"][
                          "coi"
                        ].length > 0 && (
                          <Col
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                            style={{ textAlign: "center" }}
                          >
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.fileDownload(
                                  this.state.carrierInfo["carrierFiles"][
                                    "documents"
                                  ]["coi"][0],
                                  "COI",
                                  this.state.carrierInfo["companyName"]
                                );
                              }}
                            >
                              <img src={Docsample} alt="Doc" title="Download" />
                              <h4
                                style={{ color: "#7B8190", fontSize: "13px" }}
                              >
                                Coi
                              </h4>
                            </span>
                            <span>
                              {" "}
                              <Popconfirm
                                title="Are you sure you want to delete this document?"
                                onConfirm={() => this.deleteDocument("coi")}
                                style={{ width: "100px" }}
                              >
                                <DeleteOutlined
                                  style={{
                                    color: "#7b8090",
                                    fontSize: "1.3em",
                                  }}
                                  title="Delete"
                                />
                              </Popconfirm>
                            </span>
                          </Col>
                        )}

                      {this.state.carrierInfo &&
                        this.state.carrierInfo["carrierFiles"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"][
                          "iD"
                        ] &&
                        this.state.carrierInfo["carrierFiles"]["documents"][
                          "iD"
                        ].length > 0 && (
                          <Col
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                            style={{ textAlign: "center" }}
                          >
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.fileDownload(
                                  this.state.carrierInfo["carrierFiles"][
                                    "documents"
                                  ]["iD"][0],
                                  "InsuranceDoc",
                                  this.state.carrierInfo["companyName"]
                                );
                              }}
                            >
                              <img src={Docsample} alt="Doc" title="Download" />
                              <h4
                                style={{ color: "#7B8190", fontSize: "13px" }}
                              >
                                InsuranceDoc
                              </h4>
                            </span>
                            <span>
                              {" "}
                              <Popconfirm
                                title="Are you sure you want to delete this document?"
                                onConfirm={() => this.deleteDocument("iD")}
                                style={{ width: "100px" }}
                              >
                                <DeleteOutlined
                                  style={{
                                    color: "#7b8090",
                                    fontSize: "1.3em",
                                  }}
                                  title="Delete"
                                />
                              </Popconfirm>
                            </span>
                          </Col>
                        )}
                    </Row>

                    <Row gutter={16} style={{ marginTop: "1vw" }}>
                      {this.state.carrierInfo &&
                        this.state.carrierInfo.carrierFiles &&
                        this.state.carrierInfo.carrierFiles
                          .insuranceDocuments &&
                        this.state.carrierInfo.carrierFiles
                          .insuranceDocuments && (
                          <table border="1">
                            <tr className="insurance_td_header">
                              <td width="20%" style={{ padding: "5px" }}>
                                Insurance
                              </td>
                              <td width="30%" style={{ padding: "5px" }}>
                                Policy #
                              </td>
                              <td width="25%" style={{ padding: "5px" }}>
                                Policy Amount
                              </td>
                              <td width="25%" style={{ padding: "5px" }}>
                                Expiry Date
                              </td>
                            </tr>
                            <tr className="insurance_td_data">
                              <td style={{ padding: "5px" }}>WC</td>
                              <td>
                                {
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.wc.policyNo
                                }
                              </td>
                              <td>
                                {"$ " +
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.wc.amount}
                              </td>
                              <td>
                                {moment(
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.wc.expiryDate
                                ).format("l")}
                              </td>
                            </tr>
                            <tr className="insurance_td_data">
                              <td style={{ padding: "5px" }}>AI</td>
                              <td>
                                {
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.ac.policyNo
                                }
                              </td>
                              <td>
                                {"$ " +
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.ac.amount}
                              </td>
                              <td>
                                {moment(
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.ac.expiryDate
                                ).format("l")}
                              </td>
                            </tr>
                            <tr className="insurance_td_data">
                              <td style={{ padding: "5px" }}>GLI</td>
                              <td>
                                {
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.gli.policyNo
                                }
                              </td>
                              <td>
                                {"$ " +
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.gli.amount}
                              </td>
                              <td>
                                {moment(
                                  this.state.carrierInfo.carrierFiles
                                    .insuranceDocuments.gli.expiryDate
                                ).format("l")}
                              </td>
                            </tr>
                          </table>
                        )}
                    </Row>
                  </Card>
                </div>
              </Col>

              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                style={{
                  marginTop: "2%",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                }}
              >
                <div className="site-card-border-less-wrapper">
                  <Card
                    title="Trucks"
                    style={{ borderRadius: "10px" }}
                    extra={
                      rolePermisions &&
                      rolePermisions[0]?.permissions?.includes(
                        "editCarrier"
                      ) && (
                        <span
                          onClick={this.addTruck}
                          style={{ cursor: "pointer" }}
                        >
                          <Button
                            type="dashed"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#0E4D90",
                              width: "20px",
                              borderRadius: "50%",
                              borderColor: "#0E4D90",
                              padding: "0px",
                              height: "20px",
                            }}
                          >
                            <Icon
                              type="plus"
                              style={{
                                verticalAlign: "0px",
                                fontSize: "12px",
                                color: "white",
                              }}
                            />
                          </Button>
                          &nbsp;<span>Add Truck</span>
                        </span>
                      )
                    }
                  >
                    <div className="trucktable">
                      <div
                        className="orders"
                        style={{ padding: "0px", margin: "0px" }}
                      >
                        <Table
                          columns={truckColumns}
                          pagination={false}
                          dataSource={
                            this.state.trucks ? this.state.trucks : []
                          }
                          loading={this.state.dataLoading}
                        />
                      </div>
                    </div>
                  </Card>
                </div>
                <div className="site-card-border-less-wrapper">
                  <Card
                    title="Notes"
                    extra={
                      rolePermisions &&
                      rolePermisions[0]?.permissions?.includes(
                        "editCustomer"
                      ) &&
                      this.state.loginDetails?.["richTextEditior"] ? (
                        <EditOutlined
                          key="edit"
                          onClick={() => this.showTextModal("Edit Note")}
                          style={{ fontSize: "1.4em" }}
                        />
                      ) : (
                        <span
                          onClick={() => this.showTextModal("Add Note")}
                          style={{ cursor: "pointer" }}
                        >
                          <Button
                            type="dashed"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#0E4D90",
                              width: "20px",
                              borderRadius: "50%",
                              borderColor: "#0E4D90",
                              padding: "0px",
                              height: "20px",
                            }}
                          >
                            <Icon
                              type="plus"
                              style={{
                                verticalAlign: "0px",
                                fontSize: "12px",
                                color: "white",
                              }}
                            />
                          </Button>
                          &nbsp;<span>Add Note</span>
                        </span>
                      )
                    }
                    style={{ borderRadius: "10px", marginTop: "10px" }}
                  >
                    <Row>
                      <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `${
                              this.state.loginDetails &&
                              this.state.loginDetails["richTextEditior"]
                                ? this.state.loginDetails["richTextEditior"]
                                : ""
                            }`,
                          }}
                        />
                      </Col>
                    </Row>
                  </Card>
                </div>
              </Col>
            </Col>

            <Col lg={18} md={18} sm={24} xs={24}>
              {this.state.driverVisible ? (
                <Col lg={24} md={24} sm={24} xs={24}>
                  <div className="site-card-border-less-wrapper">
                    <Card style={{ borderRadius: "10px" }}>
                      <Driverform
                        resetToPreview={this.resetToPreview}
                        orgId={this.state.carrierInfo["id"]}
                        driverId={this.state.driverId}
                      />
                    </Card>
                  </div>
                </Col>
              ) : (
                <>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <div className="site-card-border-less-wrapper">
                      <Card
                        title="Load History"
                        extra={
                          <Search
                            className="products-search"
                            size="large"
                            placeholder="Search"
                            onChange={(event) => this.searchData(event, "text")}
                          />
                        }
                        style={{ borderRadius: "10px" }}
                      >
                        <Table
                          style={{ overflowX: "auto" }}
                          columns={columns}
                          dataSource={this.state.loadHistory}
                          onChange={(pagination, filters, sorter) => {
                            this.setState({
                              loadHistory: ordersSort(
                                pagination,
                                filters,
                                sorter,
                                this.state.loadHistory
                              ),
                            });
                          }}
                          loading={this.state.dataLoading}
                          rowKey={(record) => record.id}
                          onRow={(r) => ({
                            style: { cursor: "pointer" },
                          })}
                        />
                      </Card>
                    </div>
                  </Col>
                  <Col
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ marginTop: "1%" }}
                  >
                    <div className="site-card-border-less-wrapper">
                      <Card
                        title="Drivers"
                        style={{ borderRadius: "10px" }}
                        // extra={
                        //   rolePermisions &&
                        //   rolePermisions[0]?.permissions?.includes(
                        //     "editCarrier"
                        //   ) && (
                        //     <Button
                        //       size="large"
                        //       onClick={this.addDriver}
                        //       className="submit-btn"
                        //     >
                        //       Add Driver
                        //     </Button>
                        //   )
                        // }
                      >
                        <div className="trucktable">
                          <div
                            className="orders"
                            style={{ padding: "0px", margin: "0px" }}
                          >
                            <Table
                              columns={driverColumns}
                              dataSource={this.state.drivers}
                              loading={this.state.dataLoading}
                              rowKey={(record) => record.id}
                              style={{ overflowX: "auto" }}
                            />
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Col>
                  <Col
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ marginTop: "1%" }}
                  >
                    <div className="site-card-border-less-wrapper">
                      <Card
                        title="SubUser"
                        style={{ borderRadius: "10px" }}
                        // extra={
                        //   rolePermisions &&
                        //   rolePermisions[0]?.permissions?.includes(
                        //     "editCarrier"
                        //   ) && (
                        //     <Button
                        //       size="large"
                        //       onClick={this.addDriver}
                        //       className="submit-btn"
                        //     >
                        //       Add Driver
                        //     </Button>
                        //   )
                        // }
                      >
                        <div className="trucktable">
                          <div
                            className="orders"
                            style={{ padding: "0px", margin: "0px" }}
                          >
                            <Table
                              columns={subUserColumns}
                              dataSource={this.state.subUsers}
                              loading={this.state.dataLoading}
                              rowKey={(record) => record.id}
                              style={{ overflowX: "auto" }}
                            />
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Col>
                  <Col
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ marginTop: "1%" }}
                  >
                    <div
                      className="site-card-border-less-wrapper"
                      style={{ borderRadius: "10px", marginTop: "1vw" }}
                    >
                      <Card
                        title="Carrier Audit Trail"
                        style={{ borderRadius: "10px" }}
                      >
                        <Row gutter={16}>
                          <Table
                            columns={auditColumns}
                            dataSource={carrierAuditDetails}
                            size="middle"
                            style={{ overflowX: "auto" }}
                          />
                        </Row>
                      </Card>
                    </div>
                  </Col>
                </>
              )}
            </Col>
          </Row>

          <Form>
            <Modal
              visible={this.state.visible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              closable={true}
              footer={[
                <Button
                  key="submit"
                  className="cancel"
                  onClick={this.handleCancel}
                >
                  Cancel
                </Button>,
                <Button
                  type="primary"
                  key="editSubmit"
                  htmlType="submit"
                  loading={this.state.tagLoading}
                  onClick={this.handleOk}
                >
                  Submit
                </Button>,
              ]}
            >
              <CloseOutlined
                onClick={this.handleCancel}
                style={{ float: "right", cursor: "pointer", fontSize: "1.4em" }}
              />

              <div style={{ marginTop: "10%" }}>
                <h1 style={{ textAlign: "center" }}>Add Tags</h1>
                <Form.Item className="Formitem">
                  <div>
                    <Checkbox.Group
                      onChange={(list) => {
                        this.setState({
                          selectedTags: list,
                          showErrorMsg: list.length === 0 ? true : false,
                        });
                      }}
                    >
                      {this.state.masterData
                        .sort((a, b) => (a["name"] > b["name"] ? 1 : -1))
                        .map((tag) => (
                          <>
                            <Checkbox value={tag.id} key={tag.id}>
                              {tag.name}
                            </Checkbox>
                            <br />
                          </>
                        ))}
                    </Checkbox.Group>
                  </div>
                  {this.state.showErrorMsg && (
                    <span style={{ color: "red" }}>Please select Tag!</span>
                  )}
                </Form.Item>
              </div>
            </Modal>
          </Form>

          <Form>
            <Modal
              visible={visible2}
              // onOk={this.profileHandleOk}
              // onCancel={this.profileHandleCancel}
              closable={true}
              footer={[
                <Button
                  key="submit"
                  className="cancel"
                  onClick={this.profileHandleCancel}
                >
                  Cancel
                </Button>,
                <Button
                  type="primary"
                  key="editSubmit"
                  htmlType="submit"
                  loading={this.state.loadingUpdate}
                  onClick={this.updateUserDetails}
                >
                  Update
                </Button>,
              ]}
            >
              <CloseOutlined
                onClick={this.profileHandleCancel}
                style={{ float: "right", cursor: "pointer", fontSize: "1.4em" }}
              />

              <div style={{ marginTop: "10%" }}>
                <h1 style={{ textAlign: "center" }}>Edit Carrier Details</h1>
                <Row gutter={10}>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#0E4D90" }}>First Name</span>
                      }
                    >
                      {getFieldDecorator("firstName", {
                        initialValue: "",
                        rules: [
                          {
                            required: true,
                            message: "Please input your First Name",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#0E4D90" }}>Last Name</span>
                      }
                    >
                      {getFieldDecorator("lastName", {
                        initialValue: "",
                        rules: [
                          {
                            required: true,
                            message: "Please input your Last Name",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#0E4D90" }}>Mobile Number</span>
                      }
                    >
                      {getFieldDecorator("phone", {
                        initialValue: "",
                        rules: [
                          {
                            required: true,
                            message: "Please input your Mobile Number",
                          },
                          noWhitespaceRule,
                          notValidPhoneNumberRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#0E4D90" }}>Company Name</span>
                      }
                    >
                      {getFieldDecorator("companyName", {
                        initialValue: "",
                        rules: [
                          {
                            required: true,
                            message: "Please input your Company Name",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span style={{ color: "#0E4D90" }}>DOT#</span>}
                    >
                      {getFieldDecorator("dot", {
                        initialValue: "",
                        rules: [
                          { required: true, message: "Please input your DOT#" },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span style={{ color: "#0E4D90" }}>MC#</span>}
                    >
                      {getFieldDecorator("mc", {
                        initialValue: "",
                        rules: [
                          { required: true, message: "Please input your MC#" },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>

                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span style={{ color: "#0E4D90" }}>Address</span>}
                    >
                      {getFieldDecorator("address", {
                        initialValue: "",
                        rules: [
                          {
                            required: true,
                            message: "Please input your Address",
                          },
                        ],
                      })(
                        <LocationAutocomplete
                          getAddress={(address, latLng) =>
                            this.getAddress(address, latLng, "address")
                          }
                          editMode={true}
                          address={this.state.selectedCarrierAddress}
                          setAddress={(address) => {
                            this.setState({ selectedCarrierAddress: address });
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Modal>
          </Form>

          <Form onSubmit={this.handleSubmit}>
            <Modal
              visible={this.state.documentVisible}
              title={this.state.documentTitle}
              onOk={this.handleUpload}
              onCancel={() => {
                this.setState({ documentVisible: false, documentTitle: "" });
              }}
              footer={[
                <Button
                  key="back"
                  className="cancel"
                  onClick={() => {
                    this.setState({
                      documentVisible: false,
                      documentTitle: "",
                    });
                  }}
                >
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  className="assigning"
                  loading={this.state.uploading}
                  onClick={this.handleUpload}
                >
                  Save
                </Button>,
              ]}
            >
              <Row>
                <Form.Item>
                  {getFieldDecorator("coi")}
                  <Row>
                    <Col span={10}>
                      <>
                        <img
                          src={Uploaded}
                          style={{ marginRight: 10 }}
                          alt="img"
                        />
                        COI
                      </>
                    </Col>

                    <Col span={14}>
                      <div style={{ marginLeft: "50%" }}>
                        <Upload name="coi" {...firstupload}>
                          <Button
                            onClick={() => {
                              this.setState({ uploadName: "coi" });
                            }}
                          >
                            <Icon type="upload" />
                            Upload
                          </Button>
                        </Upload>
                      </div>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator("w9")}
                  <Row>
                    <Col span={10}>
                      <>
                        <img
                          src={Uploaded}
                          style={{ marginRight: 10 }}
                          alt="img"
                        />
                        W-9
                      </>
                    </Col>
                    <Col span={14}>
                      <div style={{ marginLeft: "50%" }}>
                        <Upload name="w9" {...secondupload}>
                          <Button
                            onClick={() => {
                              this.setState({ uploadName: "w9" });
                            }}
                          >
                            <Icon type="upload" />
                            Upload
                          </Button>
                        </Upload>
                      </div>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator("nda")}
                  <Row>
                    <Col span={10}>
                      <>
                        <img
                          src={Uploaded}
                          style={{ marginRight: 10 }}
                          alt="img"
                        />
                        NDA
                      </>
                    </Col>
                    <Col span={7}>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.fileDownload(
                            this.state.carrierInfo["carrierFiles"]["documents"][
                              "nda"
                            ][0],
                            "NDA",
                            this.state.carrierInfo["companyName"]
                          );
                        }}
                      >
                        <h4
                          style={{
                            color: "#7B8190",
                            fontSize: "13px",
                            textAlign: "center",
                          }}
                        >
                          Download NDA &nbsp;{" "}
                          <img
                            src={Docsample}
                            alt="Doc"
                            title="Download"
                            style={{ width: "25px", height: "30px" }}
                          />
                        </h4>
                      </span>
                    </Col>
                    <Col span={7}>
                      <Upload name="nda" {...fourthupload}>
                        <Button
                          onClick={() => {
                            this.setState({ uploadName: "nda" });
                          }}
                        >
                          <Icon type="upload" />
                          Upload
                        </Button>
                      </Upload>
                    </Col>
                  </Row>
                </Form.Item>
              </Row>
            </Modal>
          </Form>

          <Form>
            <Modal
              visible={this.state.truckVisible}
              title={this.state.truckModalTitle}
              onOk={this.handleAddTruckOk}
              onCancel={this.handleAddTruckCancel}
              footer={[
                <Button
                  key="back"
                  className="cancel"
                  onClick={this.handleAddTruckCancel}
                >
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  className="assigning"
                  loading={this.state.truckLoading}
                  onClick={this.handleAddTruckOk}
                >
                  Save
                </Button>,
              ]}
            >
              <FormItem>
                <div style={{ marginTop: "7%" }}>
                  <Row>
                    <Col lg={24} md={24} sm={24} sx={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#0E4D90" }}>
                            Type of Truck
                          </span>
                        }
                      >
                        {getFieldDecorator("typeOfTruck1", {
                          initialValue: "",
                          rules: [
                            {
                              required: true,
                              message: "Please input your Type of Truck",
                            },
                          ],
                        })(
                          <Select
                            notFoundContent={"Not found?!"}
                            placeholder="Delivery Truck"
                            // onChange={(value) => this.setState({ deliveryTruck: value })}
                            style={{ width: "100%" }}
                          >
                            <Option value="Tractor Trailer">
                              Tractor Trailer
                            </Option>
                            <Option value="Dump Truck/Triaxle">
                              Dump Truck/Triaxle
                            </Option>
                            <Option value="Mason Dump">Mason Dump</Option>
                            <Option value="Flatbed with forklift">
                              Flatbed with forklift
                            </Option>
                            <Option value="Flatbed">Flatbed</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col lg={24} md={24} sm={24} sx={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#0E4D90" }}>Truck number</span>
                        }
                      >
                        {getFieldDecorator("truckNumber1", {
                          initialValue: "",
                          rules: [
                            {
                              required: true,
                              message: "Please input your Truck Number",
                            },
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </FormItem>
            </Modal>
          </Form>

          <Form>
            <Modal
              visible={this.state.driverEdit}
              title={`Edit ${this.state.type} Details`}
              onOk={this.handleEditDriver}
              onCancel={this.handleEditDriverCancel}
              footer={[
                <Button
                  key="back"
                  className="cancel"
                  onClick={this.handleEditDriverCancel}
                >
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  className="assigning"
                  loading={this.state.formSubmitStatus}
                  onClick={this.handleEditDriver}
                >
                  Save
                </Button>,
              ]}
            >
              <FormItem>
                <div style={{ marginTop: "7%" }}>
                  <Row gutter={10}>
                    <Col span={12}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            First Name
                          </span>
                        }
                      >
                        {getFieldDecorator("firstName", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Full Name!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Last Name
                          </span>
                        }
                      >
                        {getFieldDecorator("lastName", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Company Name!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col span={12}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Phone
                          </span>
                        }
                      >
                        {getFieldDecorator("phone", {
                          rules: [
                            { message: "The input is not valid phone number!" },
                            {
                              required: true,
                              message: "Please input your phone number!",
                            },
                            notValidPhoneNumberRule,
                            noWhitespaceRule,
                          ],
                        })(<Input style={{ width: "100%" }} />)}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Email
                          </span>
                        }
                      >
                        {getFieldDecorator("email", {
                          rules: [
                            {
                              type: "email",
                              message: "The input is not valid E-mail!",
                            },
                            {
                              required: true,
                              message: "Please input your E-mail!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input disabled={true} />)}
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </FormItem>
            </Modal>
          </Form>

          <Form>
            <Modal
              className="modal-black-close"
              title={this.state.title}
              visible={this.state.noteVisible}
              onCancel={() => {
                this.setState({ noteVisible: false });
              }}
              footer={[
                <Button
                  // key="submit"
                  className="cancel"
                  onClick={() => {
                    this.setState({ noteVisible: false });
                  }}
                >
                  Cancel
                </Button>,
                <Button
                  type="primary"
                  key="editSubmit"
                  htmlType="submit"
                  loading={this.state.loading}
                  onClick={this.updateNoteDetails}
                >
                  {this.state.buttonText}
                </Button>,
              ]}
            >
              <Row>
                <RichText
                  handleRichtextBio={this.handleRichtextBio}
                  richtTextBiofieldProp={
                    this.state.loginDetails &&
                    this.state.loginDetails.richTextEditior
                      ? this.state.loginDetails.richTextEditior
                      : ""
                  }
                />
              </Row>
            </Modal>
          </Form>

          <Modal
            visible={this.state.loginModal}
            onOk={this.handleLoginOk}
            onCancel={this.handleLoginCancel}
            closable={true}
            footer={[
              this.state.loginDetails &&
                "isActive" in this.state.loginDetails &&
                !this.state.loginDetails.isActive && (
                  <Button
                    key="submit"
                    htmlType="submit"
                    loading={this.state.avtivationLoading}
                    className="assigning"
                    onClick={() => {
                      this.resendConfirmationCode(
                        this.state.loginDetails["email"]
                      );
                    }}
                  >
                    Resend Activation Code
                  </Button>
                ),
            ]}
          >
            <CloseOutlined
              onClick={this.handleLoginCancel}
              style={{ float: "right", cursor: "pointer", fontSize: "1.4em" }}
            />

            <div style={{ marginTop: "10%" }}>
              <h1 style={{ textAlign: "center" }}>Login Details</h1>
              <p>Email</p>
              <h3>
                {this.state.loginDetails && this.state.loginDetails["email"]}
              </h3>
            </div>
          </Modal>
        </Spin>
      </div>
    );
  }
}

export default Form.create({ name: "CarrierDetails" })(
  withAppContext(withRouter(CarrierDetails))
);
